export const USER_ROLES = Object.freeze({
  USER: 'user',
  AUTHOR: 'author',
  ADMIN: 'admin',
});

export const ROLE_LABELS = Object.freeze({
  [USER_ROLES.USER]: 'Користувач',
  [USER_ROLES.AUTHOR]: 'Автор',
  [USER_ROLES.ADMIN]: 'Адміністратор',
});

export const ADMIN_TABS = Object.freeze({
  ADD_NEWS: 'add_news',
  USERS: 'users',
  EMPLOYEES: 'employees',
  SITE_NEWS: 'site_news',
  PARSED_NEWS: 'parsed_news',
});

export const ROLE_PERMISSIONS = Object.freeze({
  [USER_ROLES.USER]: Object.freeze([]),
  [USER_ROLES.AUTHOR]: Object.freeze([
    ADMIN_TABS.ADD_NEWS,
    ADMIN_TABS.SITE_NEWS,
    ADMIN_TABS.PARSED_NEWS,
  ]),
  [USER_ROLES.ADMIN]: Object.freeze(Object.values(ADMIN_TABS)),
});

export const getRoleLabel = (role) => ROLE_LABELS[role] || ROLE_LABELS.user;

export const canAccessAdminTab = (role, tab) =>
  Boolean(tab) && (ROLE_PERMISSIONS[role] || []).includes(tab);

export const canAccessAdminPanel = (role) =>
  (ROLE_PERMISSIONS[role] || []).length > 0;

export const canManageNews = (role) =>
  canAccessAdminTab(role, ADMIN_TABS.ADD_NEWS) &&
  canAccessAdminTab(role, ADMIN_TABS.SITE_NEWS);

export const canManageParsedNews = (role) =>
  canAccessAdminTab(role, ADMIN_TABS.PARSED_NEWS);

export const canManageUsers = (role) => role === USER_ROLES.ADMIN;

export const canDeleteNews = (role) => role === USER_ROLES.ADMIN;
